import React, { useEffect, useState } from 'react'
import Snackbar from '@mui/material/Snackbar'
import MuiAlert from '@mui/material/Alert'
import './ErrorSnackBar.scss'

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />
}

const ErrorSnackBar = (props) => {
  const { state, actions } = props
  const [open, setOpen] = useState(false)
  const anchor = { vertical: 'top', horizontal: 'left' }

  useEffect(() => {
    setOpen(state.open)
  }, [state.open])

  const handleClose = () => {
    setOpen(false)
    actions.setOpen(false, '')
  }

  return (
    <Snackbar anchorOrigin={anchor} open={open} autoHideDuration={state.duration} onClose={handleClose}>
      <div>
        <Alert severity={state.type}>
          {state.open === true ? (
            state.message !== '' ? (
              <span>{state.message}</span>
            ) : (
              <span>Whoops, an error occurred</span>
            )
          ) : (
            <span></span>
          )}
        </Alert>
      </div>
    </Snackbar>
  )
}

export default ErrorSnackBar
